__turbopack_context__.v({
  "container": "NbY2Mq_container",
  "variant--high": "NbY2Mq_variant--high",
  "variant--low": "NbY2Mq_variant--low",
  "variant--neutral": "NbY2Mq_variant--neutral",
  "variant--slightlyHigh": "NbY2Mq_variant--slightlyHigh",
  "variant--slightlyLow": "NbY2Mq_variant--slightlyLow",
  "variant--veryHigh": "NbY2Mq_variant--veryHigh",
  "variant--veryLow": "NbY2Mq_variant--veryLow",
});
